import React from "react";
import Marquee from "react-fast-marquee";

const platforms = [
    { name: "LinkedIn Marketing Partner", file: 32 },
    { name: "WooCommerce", file: 33 },
    { name: "Snapchat Advertising Partner", file: 34 },
    { name: "Shopify Partners", file: 35 },
    { name: "Google Partner", file: 36 },
    { name: "Salla Partners", file: 37 },
    { name: "Meta", file: 38 },
].map((p) => ({
    name: p.name,
    logo: `/assets/images/partners/1_Layer-Comp-${p.file}.webp`,
}));

const PlatformsMarquee = () => {
    return (
        <section className="overflow-hidden select-none">
            <p className="mb-6 text-center text-xs font-bold uppercase tracking-widest text-gray-600">
                شركاء رسميون معتمدون
            </p>
            <div dir="ltr" className="relative">
                <Marquee
                    gradient={true}
                    gradientColor="white"
                    gradientWidth={70}
                    speed={50}
                    pauseOnHover={true}
                    autoFill={true}
                    direction="left"
                    className="overflow-y-hidden"
                >
                    {platforms.map((platform, index) => (
                        <div
                            key={`platform-${index}`}
                            className="mx-8 md:mx-16 flex items-center justify-center group transition-all duration-500 transform cursor-pointer"
                        >
                            <img
                                src={platform.logo}
                                alt={`شعار ${platform.name} - شريك معتمد لدى ويز فريلانس`}
                                loading="lazy"
                                className="h-10 md:h-12 w-auto object-contain transition-all duration-500 filter scale-95 hover:scale-100"
                            />
                        </div>
                    ))}
                </Marquee>
            </div>
        </section>
    );
};

export default PlatformsMarquee;
